import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import style from './style/zaptic-timeline-event-style'
import type { IconName } from './helpers/icons'
import type { SupportedLocale } from 'zaptic-types'
@customElement('zaptic-timeline-event')
export class TimelineEvent extends LitElement {
    static styles = style

    @property()
    iconName: IconName = 'question-mark'

    @property()
    dateTime: string = null // ISO 8601 string

    @property()
    locale: SupportedLocale = 'en-US'

    getFormattedDateTime() {
        return new Date(Date.parse(this.dateTime)).toLocaleString(this.locale, {
            month: 'long',
            year: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
        })
    }

    render() {
        return html`<div class="container">
            <zaptic-icon class="icon" icon-name=${this.iconName}></zaptic-icon>
            <div class="details">
                <div><slot name="text">!!missing text!!</slot></div>
                <div class="date">${this.getFormattedDateTime()}</div>
            </div>
        </div>`
    }
}
